import { render, staticRenderFns } from "./createUpdateWorkflowForm.vue?vue&type=template&id=3594f242&"
import script from "./createUpdateWorkflowForm.vue?vue&type=script&lang=js&"
export * from "./createUpdateWorkflowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports